import { observer } from 'mobx-react-lite';
import ProposalSection, { ProposalSectionEditableProps } from '../ProposalSection';
import { ProposalDto } from '@gap/backend/app-services/proposal/models/ProposalDto';
import Typography from "@mui/material/Typography"
import Stack from "@mui/material/Stack"
import useStore from 'reusable/mobx-store-utils';
import ProposalSectionServicesStore, { ProposalSectionServicesStoreProvider, ServiceAgreementChangeListener } from './ProposalSectionServicesStore';
import ProposalSectionServicesItem from './ProposalSectionServicesItem';

type ProposalSectionServicesProps = {
   proposal: ProposalDto,
   sectionProps?: ProposalSectionEditableProps,
   /** Use this listener when handling client responses */
   onServiceAgreementChange?: ServiceAgreementChangeListener
}

export default observer(function ProposalSectionServices({ proposal, sectionProps, onServiceAgreementChange }: ProposalSectionServicesProps) {
   const proposalSectionServicesStore = useStore((sp) => new ProposalSectionServicesStore(sp), { proposal, onServiceAgreementChange })
   const { agreedServices, recommendedServices } = proposalSectionServicesStore

   return (
      <ProposalSectionServicesStoreProvider store={proposalSectionServicesStore}>
         <ProposalSection heading="Proposed Services" {...sectionProps} sx={{ '> *': { gap: 4 } }}>
            {
               agreedServices.length > 0 && <Stack sx={{ gap: 3 }}>
                  {agreedServices.map((service) => <ProposalSectionServicesItem
                     key={service.serviceId}
                     {...{ service }}
                     selection={{
                        enabled: false,
                        isSelected: true,
                     }}
                  />)}
               </Stack>
            }
            {
               recommendedServices.length > 0 && <Stack>
                  <Typography variant="overline" sx={{ mb: 1.5, ml: 6 }}>Recommended</Typography>
                  <Stack sx={{ gap: 3 }}>
                     {recommendedServices.map((service) => <ProposalSectionServicesItem
                        key={service.serviceId}
                        {...{ service }}
                        selection={{
                           enabled: !proposal.response?.includedOptionalServiceIds,
                           isSelected: proposalSectionServicesStore.serviceAgreementMap[service.serviceId],
                           onSelectionChange: proposalSectionServicesStore.onServiceAgreementChange
                        }}
                     />)}
                  </Stack>
               </Stack>
            }
         </ProposalSection>
      </ProposalSectionServicesStoreProvider>
   )
})
